import React from 'react'
import { useTranslation } from 'react-i18next'

interface PricingRow {
    gpus: string
    vramPerGpu: string
    vcpus: number
    ram: string
    storage: string
    price: string
}

const Pricing = () => {
    const { t } = useTranslation()

    const pricingData: PricingRow[] = [
        { gpus: '4x NVIDIA A100 PCIe', vramPerGpu: '40 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$4.00 / hr' },
        { gpus: '2x NVIDIA A100 PCIe', vramPerGpu: '40 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$2.09 / hr' },
        { gpus: '1x NVIDIA A100 PCIe', vramPerGpu: '40 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$1.09 / hr' },
        { gpus: '1x NVIDIA RX 3090', vramPerGpu: '24 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$0.65 / hr' },
        { gpus: '2x NVIDIA RX 3090', vramPerGpu: '24 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$1.22 / hr' },
        { gpus: '4x NVIDIA RX 3090', vramPerGpu: '24 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$2.43 / hr' },
        { gpus: '1x AMD RX 590', vramPerGpu: '8 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$0.25 / hr' },
        { gpus: '2x AMD RX 590', vramPerGpu: '8 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$0.45 / hr' },
        { gpus: '4x AMD RX 590', vramPerGpu: '8 GB', vcpus: 24, ram: '200 GiB', storage: '512 GiB SSD', price: '$0.85 / hr' }
    ]

    return (
        <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold tracking-tight">{t('pricing.title')}</h2>
                <p className="mt-4 text-muted-foreground">{t('pricing.subtitle')}</p>
            </div>
            <div className="overflow-x-auto rounded-lg border">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-[hsl(220,26%,14%)] text-white">
                            <th className="px-4 py-3 text-left text-xs uppercase tracking-wider font-semibold">{t('pricing.gpus')}</th>
                            <th className="px-4 py-3 text-left text-xs uppercase tracking-wider font-semibold">{t('pricing.vram')}</th>
                            <th className="px-4 py-3 text-left text-xs uppercase tracking-wider font-semibold">{t('pricing.vcpus')}</th>
                            <th className="px-4 py-3 text-left text-xs uppercase tracking-wider font-semibold">{t('pricing.ram')}</th>
                            <th className="px-4 py-3 text-left text-xs uppercase tracking-wider font-semibold">{t('pricing.storage')}</th>
                            <th className="px-4 py-3 text-left text-xs uppercase tracking-wider font-semibold">{t('pricing.price')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pricingData.map((data, index) => (
                            <tr key={index} className="border-t hover:bg-muted/25 transition-colors">
                                <td className="px-4 py-3 font-medium">{data.gpus}</td>
                                <td className="px-4 py-3">{data.vramPerGpu}</td>
                                <td className="px-4 py-3">{data.vcpus}</td>
                                <td className="px-4 py-3">{data.ram}</td>
                                <td className="px-4 py-3">{data.storage}</td>
                                <td className="px-4 py-3 font-semibold text-primary">{data.price}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    )
}

export default Pricing
